<template>
  <div class="home">
      <div class="container">
          <!-- <img src="../assets/shark.jpg" alt="" class="image-shark"> -->
        <h3 class = "tiny-header">
          Tired of playing among us?
        </h3>
        <h2 class = "header-text" >
          The Curious Case of 
        </h2>
          <img src="https://i.pinimg.com/originals/10/e0/5f/10e05fe78c4e47549a4a950ca9739d66.jpg" alt="" class="detective-image">
        
        <h2 class = "header-text jones" >
          Professor Jones 
        </h2>
        <button class="action-button" v-on:click="handleButtonClick ">
            Start
        </button>
        <h3 class = "tiny-header">
          DO you have that 10000 IQ brain to crack the case and be among the top detectives in the game?
        </h3>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Landing',
  components: {
    
  },
  methods:{
    handleButtonClick(){
      this.$router.push({name:'Intro'}  );
    }
  }
}
</script>

<style>
.detective-image{
  width: 424px;
  height: 259px;
}
.container {
  display:flex;
  align-items:center;
  justify-content: center;
  flex-direction: column;
}
.jones{
  color: #FF5C5C;
}
.header-text{
  font-size: 64px;
}
.action-button{
  background-color: #FF5C5C;
  font-size: 32px;
  color: white;
  font-family: 'Poppins';
  width: 312px;
  height: 63px;
  border:none;
  border-radius: 20px;
}
.action-button:hover{
  cursor:pointer;
  opacity: 0.6;
}
</style>